import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FormAlert, PillButton } from "@NP-Webber/crm-kit";
import { toClientApiError } from "../api/httpClient";
import { useAuth } from "../auth/AuthProvider";
import { activeMemberships } from "../auth/authState";
import { formatOrganizationCode } from "../modules/organizations/orgDisplay";
import "../styles/authTheme.css";

export function TenantSelectPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [loadingId, setLoadingId] = useState<string | null>(null);
  const [error, setError] = useState("");

  const options = activeMemberships(auth.memberships);

  const handleSelect = async (tenantId: string) => {
    setError("");
    setLoadingId(tenantId);
    try {
      await auth.selectTenant(tenantId);
      navigate("/", { replace: true });
    } catch (err) {
      setError(toClientApiError(err).message);
    } finally {
      setLoadingId(null);
    }
  };

  return (
    <div className="auth-gate-page">
      <div className="auth-gate-card">
        <h1>בחירת ארגון</h1>
        <p>יש לכם גישה לכמה ארגונים. בחרו ארגון כדי להמשיך.</p>
        {error ? <FormAlert severity="error">{error}</FormAlert> : null}
        <ul className="tenant-list">
          {options.map((m) => (
            <li key={m.membershipId}>
              <button
                type="button"
                className="tenant-list__btn"
                disabled={loadingId !== null}
                onClick={() => handleSelect(m.tenantId)}
              >
                {formatOrganizationCode(m.tenantCode)} — {m.tenantName}
                <span className="tenant-list__slug">{m.tenantSlug}</span>
              </button>
            </li>
          ))}
        </ul>
        <PillButton
          variant="ghost"
          disabled={loadingId !== null}
          onClick={() => auth.logout()}
        >
          התנתק
        </PillButton>
      </div>
    </div>
  );
}

export default TenantSelectPage;
